export const TOUS = 'TOUS'
export const ABONNE = 'ABONNE'
export const NON_ABONNE = 'NON_ABONNE'

export const PUBLIC_VISE_PAR_DEFAUT = { code: TOUS, libelle: 'Tous les adhérents' }

export const PUBLICS_VISES = [
  { code: ABONNE, libelle: 'Adhérents abonnés' },
  { code: NON_ABONNE, libelle: 'Adhérents non abonnés' },
  { code: TOUS, libelle: 'Tous les adhérents' }
]

const CODE_PAR_LIBELLE = Object.fromEntries(PUBLICS_VISES.map(p => [p.libelle, p.code]))

export function codePublicVise (redirection) {
  const cible = redirection?.cible
  const code = typeof cible === 'string' ? (CODE_PAR_LIBELLE[cible] || cible) : cible?.code

  return PUBLICS_VISES.some(p => p.code === code) ? code : PUBLIC_VISE_PAR_DEFAUT
}

export function isRebondVisiblePourAdherent (redirection, isAbonneCulturial) {
  switch (codePublicVise(redirection)) {
    case ABONNE:
      return isAbonneCulturial === true
    case NON_ABONNE:
      return isAbonneCulturial !== true
    default:
      return true
  }
}
